export const DEFAULT_OFFER_PERF_GROUP_BY = ['offer'];
export const DEFAULT_EXP_PERF_GROUP_BY = ['experience', 'reason'];

export const resolvePerfReportGroupBy = (
  saved: readonly (string | undefined)[] | undefined,
  availableNames: readonly string[],
  fallback: readonly string[]
): string[] => {
  const available = new Set(availableNames);
  const kept = (saved ?? fallback).filter(
    (key): key is string => typeof key === 'string' && available.has(key)
  );
  return kept.length > 0 ? kept : [...fallback];
};
